import {getRequest} from "./api";
import router from "../router";
import store from "../store";

export const initMenu = (router, store) => {
  if (store.state.routes.length > 0) {
    return;
  }
  getRequest("/loadAllTopMenusOfCurrentUser").then(data => {
      if (data) {
        let fmtRoutes = formatRoutes(data.menuList);
        router.addRoutes(fmtRoutes);
        store.commit('initRoutes', fmtRoutes);
        // store.dispatch('connect');

        /*
         let needSetPassword = window.sessionStorage.getItem("needSetPassword");
         if (needSetPassword != null) {
           if (needSetPassword === "true") {
             router.push('/setPassword').catch(err => (
               console.log(err)
             ));
           }
         } else {
           router.replace({path: '/'});
         }
         */
      }
    }
  )
}
export const formatRoutes = (routes) => {
  let fmRoutes = [];
  routes.forEach(router => {
    let {
      path,
      component,
      name,
      iconCls,
      keepAlive,
      requireAuth,
      children
    } = router;
    if (children && children instanceof Array && children.length > 0) {
      children = formatRoutes(children);
    } else {
      children = null;
    }
    let meta = {
      keepAlive,
      requireAuth
    };
    let fmRouter = {
      path: path,
      name: name,
      iconCls: iconCls,
      meta: meta,
      children: children,
      component(resolve) {
        if (component.startsWith("Home")) {
          require(['../views/' + component + '.vue'], resolve);
        } else if (component.startsWith("StudentGraduationDesignStatisticsBasic")) {
          require(['../views/studentgraduationdesignstatistics/' + component + '.vue'], resolve);
        } else if (component.startsWith("InstructorThesisStatisticsBasic")) {
          require(['../views/instructorthesisstatistics/' + component + '.vue'], resolve);
        } else if (component.startsWith("InstructorTopicStatisticsBasic")) {
          require(['../views/instructortopicstatistics/' + component + '.vue'], resolve);
        } else if (component.startsWith("InstructorGuideStatisticsBasic")) {
          require(['../views/instructorguidestatistics/' + component + '.vue'], resolve);
        } else if (component.startsWith("InstructorLoginStatisticsBasic")) {
          require(['../views/instructorloginstatistics/' + component + '.vue'], resolve);
        } else if (component.startsWith("DesignTitleWaitModifyStatisticsBasic")) {
          require(['../views/designtitlewaitmodifystatistics/' + component + '.vue'], resolve);
        } else if (component.startsWith("ResitAppliedStatisticsBasic")) {
          require(['../views/resitappliedstatistics/' + component + '.vue'], resolve);
        } else if (component.startsWith("DesignTitleSubmittedStatisticsBasic")) {
          require(['../views/designtitlesubmittedstatistics/' + component + '.vue'], resolve);
        } else if (component.startsWith("SemesterManageBasic")) {
          require(['../views/semestermanage/' + component + '.vue'], resolve);
        } else if (component.startsWith("UserManageBasic")) {
          require(['../views/usermanage/' + component + '.vue'], resolve);
        } else if (component.startsWith("UploadFileManageBasic")) {
          require(['../views/uploadfilemanage/' + component + '.vue'], resolve);
        }  else if (component.startsWith("ScoreManageBasic")) {
          require(['../views/scoremanage/' + component + '.vue'], resolve);
        } else if (component.startsWith("FinalThesisApproveManageBasic")) {
          require(['../views/finalthesisapprovemanage/' + component + '.vue'], resolve);
        } else if (component.startsWith("DefenceApplyManageBasic")) {
          require(['../views/defenceapplymanage/' + component + '.vue'], resolve);
        } else if (component.startsWith("AgreeThesisManageBasic")) {
          require(['../views/agreethesismanage/' + component + '.vue'], resolve);
        } else if (component.startsWith("PretrialManageBasic")) {
          require(['../views/pretrialmanage/' + component + '.vue'], resolve);
        } else if (component.startsWith("ResitManageBasic")) {
          require(['../views/resitmanage/' + component + '.vue'], resolve);
        }else if (component.startsWith("StudentGraduationDesignManageBasic")) {
          require(['../views/studentgraduationdesignmanage/' + component + '.vue'], resolve);
        } else if (component.startsWith("DesignStudent")) {
          require(['../views/designstudentmanage/' + component + '.vue'], resolve);
        } else if (component.startsWith("Notice")) {
          require(['../views/notice/' + component + '.vue'], resolve);
        } else if (component.startsWith("SysParam")) {
          require(['../views/systemparam/' + component + '.vue'], resolve);
        } else if (component.startsWith("Task") || component.startsWith("TaskOfUniversity")) {
          require(['../views/task/' + component + '.vue'], resolve);
        } else if (component.startsWith("ExaminationPlace") || component.startsWith("ExaminationArrangement")
          || component.startsWith("TeachingCenterMajor") || component.startsWith("TeachingCenterRecord")) {
          require(['../views/business/' + component + '.vue'], resolve);
        }
        //   else if (component.startsWith("User") || component.startsWith("SetPassword") || component.startsWith("UserGroup") || component.startsWith("Role")
        //   || component.startsWith("Module") || component.startsWith("Operation") || component.startsWith("WebResource")
        //   || component.startsWith("Auth")) {
        //   require(['../views/rbac/' + component + '.vue'], resolve);
        // }
          else if (component.startsWith("Nation") || component.startsWith("PoliticalParty") || component.startsWith("Education")
          || component.startsWith("TechnicalPost") || component.startsWith("Area")
          || component.startsWith("Major") || component.startsWith("MajorDirection")
          || component.startsWith("SchoolLevel") || component.startsWith("EducationLevel") || component.startsWith("StudyWay")
          || component.startsWith("CertificateType") || component.startsWith("EnrollmentBatch")
          || component.startsWith("Sponsor") || component.startsWith("UniversityType")
          || component.startsWith("StudentStatus") || component.startsWith("CultivateWay")
          || component.startsWith("TeachingCenterType") || component.startsWith("ExaminationType") || component.startsWith("ExaminationWay")
          || component.startsWith("TeacherType") || component.startsWith("StaffType") || component.startsWith("TeacherType") || component.startsWith("SupportingUnitType")) {
          require(['../views/basic/' + component + '.vue'], resolve);
        } else if (component.startsWith("University") || component.startsWith("TeachingCenterStudyWay") || component.startsWith("TeachingCenter")) {
          require(['../views/organization/' + component + '.vue'], resolve);
        } else if (component.startsWith("Student") || component.startsWith("Teacher") || component.startsWith("Staff")) {
          require(['../views/personnel/' + component + '.vue'], resolve);
        }
      }
    }
    fmRoutes.push(fmRouter);
  })
  return fmRoutes;
}



// WEBPACK FOOTER //
// ./src/utils/menus.js